import { render, staticRenderFns } from "./StatisticCardMDB.vue?vue&type=template&id=2974091b&scoped=true&"
import script from "./StatisticCardMDB.vue?vue&type=script&lang=js&"
export * from "./StatisticCardMDB.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCardMDB.vue?vue&type=style&index=0&id=2974091b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974091b",
  null
  
)

export default component.exports